export class HistoryDb {
  db: string
  table: string
  cnx: any

  constructor() {
    this.db = 'history'
    this.table = 'items'
  }

  openDb(): any {
    return new Promise((resolve) => {
      const request = window.indexedDB.open(this.db, 1)

      request.onsuccess = () => {
        this.cnx = request.result
        resolve(true)
      }

      request.onupgradeneeded = (changeEvent: any) => {
        const objectStore = changeEvent.target.result.createObjectStore(
          this.table,
          {
            keyPath: 'baseSet',
            autoIncrement: false,
          }
        )

        objectStore.onsuccess = () => {
          this.cnx = changeEvent.target.result
          resolve(true)
        }

        objectStore.createIndex('timestamp', 'timestamp', { unique: false })
      }
    })
  }

  put(entity: object) {
    return new Promise((resolve) => {
      this.cnx
        .transaction([this.table], 'readwrite')
        .objectStore(this.table)
        .put(entity).onsuccess = () => {
        resolve(true)
      }
    })
  }

  delete(baseSet: string) {
    return new Promise((resolve) => {
      if (baseSet !== '') {
        this.cnx
          .transaction([this.table], 'readwrite')
          .objectStore(this.table)
          .delete(baseSet).onsuccess = () => {
          resolve(true)
        }
      } else {
        resolve(false)
      }
    })
  }

  clear() {
    return new Promise((resolve) => {
      this.cnx
        .transaction([this.table], 'readwrite')
        .objectStore(this.table)
        .clear()
        .onsuccess(() => {
          resolve(true)
        })
    })
  }

  getAll() {
    return new Promise((resolve) => {
      const result: any = []

      const objectStore = this.cnx
        .transaction([this.table], 'readwrite')
        .objectStore(this.table)

      objectStore.index('timestamp').openCursor(null, 'prev').onsuccess = (
        event: any
      ) => {
        const cursor = event.target.result
        if (cursor) {
          result.push(cursor.value)
          cursor.continue()
        }
      }

      objectStore.transaction.oncomplete = () => {
        resolve(result)
      }
    })
  }

  reduce(limit: number) {
    return new Promise((resolve) => {
      const result: any = []
      const self = this

      const objectStore = this.cnx
        .transaction([this.table], 'readwrite')
        .objectStore(this.table)

      objectStore.index('timestamp').openCursor(null, 'prev').onsuccess = (
        event: any
      ) => {
        const cursor = event.target.result
        if (cursor) {
          if (limit < 1) {
            self.delete(cursor.value.baseSet).then(() => {})
          }
          limit--
          cursor.continue()
        }
      }

      objectStore.transaction.oncomplete = () => {
        resolve(result)
      }
    })
  }
}
